import { FC } from 'react'
import { LinearProgress, LinearProgressProps } from '@mui/material'
import styles from '@norstella/nxp-sso-web/components/LoadingIndicator.module.scss'

export const LoadingIndicator: FC<LinearProgressProps> = (props) =>
  <LinearProgress {...props} className={props.className || styles.loadingIndicator}/>
